module.exports = __webpack_public_path__ + "static/img/7bg_3.cbaa719.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_3.png
// module id = 740
// module chunks = 1